
define('text!libs/strand/gulp/templates/lib_template.html',[],function () { return '{{#shared}}\n<link rel="import" href="{{.}}">\n{{/shared}}\n{{#modules}}\n<link rel="import" href="{{.}}/{{.}}.html">\n{{/modules}}\n';});

